import { Box, Button, TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import colorRectangle from 'src/images/colorRectangle.png';
import { RootState, useSelector } from 'src/store';
import {
  editText,
  editFontWeight,
  editColor,
  editFontSize,
  editTextAlign,
  editFontFamily
} from 'src/store/modules/editText';

import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import AlignLeft from 'src/components/Icon/AlignLeft';
import AlignCenter from 'src/components/Icon/AlignCenter';
import AlignRight from 'src/components/Icon/AlignRight';

import ChevronUp from 'src/components/Icon/ChevronUp';
import ChevronDown from 'src/components/Icon/ChevronDown';
import FontFamilyPicker from 'src/components/editor/FontFamilyPicker';

interface editTextProps {
  type: string;
}

const FONT_WEIGHT_ENUM: any = {
  300: 'Light',
  400: 'Regular',
  500: 'Medium',
  600: 'SemiBold',
  700: 'Bold',
  800: 'Custom'
};

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0 0.78rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    height: '4.5rem',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    // margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

const EditFontFamily: FC<editTextProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isFontFamily, setIsFontFamily] = useState(false);

  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);

  const handleFontFamily = (family: string, weight: number) => {
    let newFontFamily = JSON.parse(JSON.stringify(fontFamily));
    newFontFamily[type] = family;
    let newFontWeight = JSON.parse(JSON.stringify(fontWeight));
    newFontWeight[type] = weight;
    dispatch(editFontFamily(newFontFamily));
    dispatch(editFontWeight(newFontWeight));
    setIsFontFamily(false);
  };

  return (
    <>
      <div
        className={classes.fontBox}
        onClick={() => {
          setIsFontFamily(!isFontFamily);
        }}
      >
        <span>{`${fontFamily[type]} [${
          FONT_WEIGHT_ENUM[fontWeight[type]]
        }]`}</span>
        {isFontFamily ? (
          <ChevronUp
            style={{
              width: '1.5rem',
              height: '1.5rem'
            }}
          />
        ) : (
          <ChevronDown
            style={{
              width: '1.5rem',
              height: '1.5rem'
            }}
          />
        )}
      </div>
      {isFontFamily && (
        <FontFamilyPicker
          oriFontFamily={fontFamily[type]}
          oriFontWeight={fontWeight[type]}
          handleFontFamily={handleFontFamily}
        />
      )}
    </>
  );
};

export default EditFontFamily;
